export default "/_next/static/images/ARRuler-5f768377f0e8a2581bad57dc3485fe82.png";